import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { formatImageInfoCardListData } from '@/utils/homepageUtils';

import HtmlESpot from '@/components/layout/espots/HtmlESpot';
import VideoESpot from '@/components/layout/espots/VideoESpot';
import InfoCard from '@/components/common/InfoCardList/InfoCard';
import ImageCard from '@/components/common/ImageCardList/ImageCard';
import TextIconEspot from '@/components/layout/espots/TextIconESpot';
import AccordionEspot from '@/components/layout/espots/AccordionESpot';
import EmptyItemEspot from '@/components/layout/espots/EmptyItemEspot';
import TrustedShopESpot from '@/components/layout/espots/TrustedShopESpot';
import ImageInfoCard from '@/components/common/ImageInfoCardList/ImageInfoCard';
import { ESPOT_CARD_TYPE, ESPOT_TYPE } from '@/constants/espot';

export const ESpot = ({ spot, locale, customClassName }) => {
  const component = useMemo(() => {
    const componentsMap = {
      [ESPOT_TYPE.CARD]: () => {
        if (spot.cardType === ESPOT_CARD_TYPE.CARD_1) {
          return <ImageInfoCard data={formatImageInfoCardListData(spot)} />;
        } else {
          return <InfoCard data={spot} borderColor={{ color: 'black' }} breakpoint={'sm'} />;
        }
      },
      [ESPOT_TYPE.HTML]: () => <HtmlESpot data={spot} />,
      [ESPOT_TYPE.HTML_WITH_LINK]: () => <HtmlESpot data={spot} />,
      [ESPOT_TYPE.SAMPLE]: () => <ImageCard data={spot} />,
      [ESPOT_TYPE.TEXT_ICON]: () => (
        <TextIconEspot icon={spot.img} desc={spot.desc} alt={spot.alt} backgroundColor={spot.backgroundColor} />
      ),
      [ESPOT_TYPE.VIDEO]: () => <VideoESpot data={spot} lang={locale || 'fr-FR'} />,
      [ESPOT_TYPE.ACCORDION]: () => <AccordionEspot data={spot} />,
      [ESPOT_TYPE.ESPOT_TRUSTED_SHOP]: () => <TrustedShopESpot data={spot} />,
      [ESPOT_TYPE.EMPTY_ITEM]: () => <EmptyItemEspot img={spot.img} title={spot.title} desc={spot.desc} redirect={spot.redirect} />
    };

    return componentsMap[spot?.type]?.() || null;
  }, [locale, spot]);

  return component && (
    <div className={customClassName} data-test-id="espot" id={spot.htmlId}>
      {component}
    </div>
  );
};

ESpot.propTypes = {
  spot: PropTypes.object,
  locale: PropTypes.string,
  customClassName: PropTypes.string
};

export default React.memo(ESpot);
